export default __webpack_public_path__ + "static/media/pk-pro-cover.7998942a.jpg";